import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";

export default function HamburgerMenu() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={() => setOpen(true)}
        className="
          w-10 h-10 flex items-center justify-center
          rounded-full
          bg-gradient-to-tr from-[#6366f1] to-[#818cf8]
          shadow-md
          hover:scale-110 transition-transform
        "
        aria-label="Toggle menu"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-5 h-5"
        >
          <path d="M3 6h18M3 12h18M3 18h18" />
        </svg>
      </button>

      {open &&
        ReactDOM.createPortal(
          <div
            className="
              fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-10
              bg-gradient-to-br from-[#0f172a]/80 via-[#1e293b]/70 to-[#0f172a]/80
              backdrop-blur-xl
              animate-fade-in
            "
          >
            {/* Close Button */}
            <button
              onClick={() => setOpen(false)}
              className="
                absolute top-8 right-8
                text-white text-4xl font-bold
                hover:text-[#6366f1] transition-colors
              "
              aria-label="Close menu"
            >
              &times;
            </button>

            {/* Menu Items */}
            <nav className="flex flex-col items-center gap-8">
              <Link
                to="/text-behind-image"
                onClick={() => setOpen(false)}
                className="
                  text-3xl font-bold text-white
                  hover:text-[#a5b4fc] transition-colors
                "
              >
                Text-Behind-Image
              </Link>

              <Link
                to="/blog"
                onClick={() => setOpen(false)}
                className="
                  px-8 py-3 rounded-full
                  text-white text-lg font-semibold
                  bg-gradient-to-tr from-[#6366f1] to-[#818cf8]
                  shadow-xl hover:shadow-2xl
                  hover:scale-105 transition-all
                "
              >
                Blog
              </Link>
            </nav>
          </div>,
          document.body
        )}
    </>
  );
}
